import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Shuffle: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m569.29 523.19h-71.68c-2.18 0-4.22-1.01-5.43-2.67l-203.12-280.68c-6.86-9.42-17.96-15.05-29.71-15.05h-75.08s-35 0-35 0c-16.57 0-30 13.43-30 30h90s50.08 0 50.08 0c2.18 0 4.22 1.01 5.42 2.67l203.12 280.68c6.86 9.42 17.96 15.05 29.71 15.05h71.68v-30z' />
    <path d='m492.18 259.27.13-.17c1.22-1.68 3.24-2.69 5.31-2.7h71.68v-30h-71.77c-11.61.07-22.59 5.66-29.41 14.95l-70.83 94.45 24 18 70.88-94.52z' />
    <path d='m264.79 522.12c-1.23 1.67-3.26 2.67-5.42 2.67h-75.08s-35 0-35 0c-16.57 0-30 13.43-30 30h90s50.07 0 50.07 0c11.74 0 22.84-5.63 29.7-15.05l72.42-101.22-24.4-17.46-72.3 101.06z' />
    <path d='m539 317.21 20.58 21.83 101.13-95.34-97.37-99.41-21.43 21 75.97 77.56z' />
    <path d='m563.34 440.96-21.43 20.99 75.97 77.57-78.88 74.36 20.58 21.83 101.13-95.34z' />
  </IconBase>
));

Shuffle.displayName = 'Shuffle';

export default Shuffle;
